// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U3tK","toggle":"styles_toggle__2jf88","preview":"styles_preview__1wqE6"};